<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <el-form
      :model="receivableFormData"
      :rules="rules"
      ref="receivableForm"
      label-width="120px"
      class="import-policy-info-form"
    >
      <div class="form-item-wrapper">
        <el-form-item
          :label="`批量${initParams.title}明细：`"
          prop="receivableOrderExcelUrlList"
        >
          <el-upload
            action=""
            accept=".xls,.xlsx"
            :file-list="receivableFormData.receivableOrderExcelUrlList"
            :limit="1"
            :http-request="uploadRequest"
            :autoUpload="true"
            :show-file-list="true"
            :on-remove="handleFileMove"
          >
            <el-button
              type="minor"
              slot="trigger"
              :loading="fileUploading"
              :disabled="
                receivableFormData.receivableOrderExcelUrlList.length > 0
              "
            >
              点击上传
            </el-button>
            <el-button type="text" size="small"
              ><a :href="initParams.templateUrl">下载导入模板</a></el-button
            >
          </el-upload>
        </el-form-item>
      </div>
      <div class="form-item-wrapper">
        <el-form-item
          :label="`${initParams.title}凭证：`"
          prop="receivableVoucherUrlList"
        >
          <UploadCommon
            :listType="listType"
            :isAlone="false"
            :limit="6"
            :fileList.sync="receivableFormData.receivableVoucherUrlList"
            :sizeType="4"
            commonUpload
            group="finance"
            :code="codeupload"
          />
        </el-form-item>
      </div>
      <div class="form-item-wrapper">
        <el-form-item prop="remarks" label="备注">
          <el-input
            type="textarea"
            :rows="3"
            maxlength="500"
            show-word-limit
            placeholder="请输入"
            v-model="receivableFormData.remarks"
          />
        </el-form-item>
      </div>
    </el-form>
    <div class="dialog-footer-box">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button
        type="primary"
        @click="handleEnter"
        :loading="fileUploading"
        :disabled="fileUploading"
        v-submitDingTalkShow="initParams.submitDingTalkShow"
        >{{ btnTitle }}</el-button
      >
    </div>
  </div>
</template>

<script>
import { submitDingTalkShow } from '@/directives/submitDingTalkShow'
import * as globalApi from '@/api/global'
import axios from 'axios'
import { interfacePrefix } from '@/config'
import { getHead } from '@/utils'
import {
  SubmitFormBaseModel,
  ReceivableSubmitFormBaseModel,
  PaymentSubmitFormBaseModel,
  UploadConfigMapper,
} from './model.js'

export default {
  name: 'SubmitForm',
  /** 钉钉审批流是否存在审批配置 2023/09/25 */
  directives: {
    submitDingTalkShow,
  },
  props: {
    scenetype: {
      type: String,
    },
  },
  watch: {
    'receivableFormData.receivableVoucherUrlList': {
      handler(val) {
        if (val && val.length > 0) {
          this.$refs.receivableForm.clearValidate('receivableVoucherUrlList')
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      DingTalkShow1: false, // 是否开启审批
      DingTalkShow22: false, // 是否开启审批
      fileUploading: false,
      receivableFormData: {
        receivableOrderExcelUrlList: [],
        receivableVoucherUrlList: [],
        remarks: '',
      },
    }
  },
  computed: {
    listType() {
      return this.scenetype === 'receivable' ? 'text' : ''
    },
    codeupload() {
      return UploadConfigMapper.get(this.scenetype)
    },
    btnTitle() {
      if (this.scenetype === 'receivable') return this.initParams.btnTitle
      if (this.scenetype === 'payment' && this.DingTalkShow22) return '提交审批'
      return this.initParams.btnTitle
    },
    initParams() {
      if (this.scenetype === 'receivable') return ReceivableSubmitFormBaseModel
      if (this.scenetype === 'payment') return PaymentSubmitFormBaseModel
      return SubmitFormBaseModel
    },
    rules() {
      const baseRule = {
        receivableOrderExcelUrlList: [
          {
            required: true,
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!value || !Array.isArray(value) || value.length !== 1) {
                callback(new Error(`请上传批量${this.initParams.title}明细`))
                return
              }
              callback()
            },
          },
        ],
        remarks: [
          { required: false },
          {
            min: 1,
            max: 500,
            message: '长度在 1 到 500 个字符',
            trigger: 'blur',
          },
        ],
      }
      if (this.scenetype === 'payment') {
        return baseRule
      }
      return {
        ...baseRule,
        receivableVoucherUrlList: [
          {
            required: true,
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (
                !value ||
                !Array.isArray(value) ||
                value.length === 0 ||
                value.length > 6
              ) {
                callback(new Error(`请上传${this.initParams.title}凭证`))
                return
              }
              callback()
            },
          },
        ],
      }
    },
  },
  methods: {
    // 获取钉钉审批按钮开启
    async getDingTalkBtnShow() {
      const { code, data } = await globalApi
        .getSubmitDingTalkShow({
          bizType: 1,
        })
      if (code === 1) {
        this.DingTalkShow1 = data
      }
    },
    /* 自定义上传 */
    uploadRequest({ file }) {
      const size = file.size / 1024 / 1024
      if (size > 200) {
        this.$message.error('文件大小不能超过 200MB，建议拆分后再进行操作')
        return
      }
      // eslint-disable-next-line no-useless-escape
      const isExcel = /^(application\/).*((\.sheet)|(\.ms\-excel))$/.test(
        file.type,
      )
      if (!isExcel) {
        this.receivableFormData.receivableOrderExcelUrlList = []
        this.$message.error('请上传Excel文件')
        return
      }
      this.fileUploading = true
      const formData = new FormData()
      formData.append('file', file)
      formData.append('group', 'finance')
      formData.append('code', this.codeupload)
      axios({
        url: `${interfacePrefix}/fs/standard/upload`,
        method: 'POST',
        data: formData,
        headers: {
          ...this.headers,
          ...getHead(this.$store),
        },
        onUploadProgress: ({ loaded, total }) => {
          this.isProgress = true
          this.disabled = true
          this.uploadPercent = parseInt(loaded / total)
        },
      })
        .then(({ data: { code, data, msg } }) => {
          if (code === 1) {
            this.fileUploading = false
            file.url = data
            this.receivableFormData.receivableOrderExcelUrlList.push(file)
            this.$refs.receivableForm.clearValidate('receivableOrderExcelUrlList')
          } else {
            this.$message.error(msg)
            this.fileUploading = false
          }
        })
        .catch(() => {
          this.fileUploading = false
        })
    },
    handleFileMove() {
      this.fileUploading = false
      this.receivableFormData.receivableOrderExcelUrlList = []
    },
    handleCancel() {
      this.$refs.receivableForm.resetFields({})
      this.$refs.receivableForm.clearValidate({})
      this.$emit('update:visible', false)
    },
    async handleEnter() {
      const valid = await this.$refs.receivableForm.validate()
      if (!valid) return
      // 应收 , // 审批模式 1:后台审批 2:钉钉审批)
      if (this.scenetype === 'receivable') {
        await this.getDingTalkBtnShow()
      }
      const receivableOrderExcelUrl = this.receivableFormData
        ?.receivableOrderExcelUrlList[0]?.url
      const receivableVoucherUrlList = JSON.stringify(
        this.receivableFormData.receivableVoucherUrlList?.map((ulv) => ulv.url) ||
          [],
      )
      const params = {
        [this.initParams.postDataKey.urlKey]: receivableOrderExcelUrl,
        [this.initParams.postDataKey.urlListKey]: receivableVoucherUrlList,
        remarks: this.receivableFormData?.remarks,
      }
      // DingTalkShow1 应收 , // 审批模式 1:后台审批 2:钉钉审批)
      if (this.scenetype === 'receivable') {
        params.approvalAccessMode = this.DingTalkShow1 ? 2 : 1
      }
      // DingTalkShow22 应付 , // 审批模式  2:钉钉审批)
      if (this.scenetype === 'payment' && this.DingTalkShow22) {
        params.approvalAccessMode = 2
      }
      const res = await this.initParams.postUrl(params)
      if (res.code === 1) {
        this.$message.success('提交成功')
        this.$emit('handleSuccess', this.DingTalkShow1 || this.DingTalkShow22)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .upload {
  margin-left: 0px !important;
}
.dialog-footer-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

::v-deep .el-form-item.is-error + .info-slot {
  top: -4px;
}

</style>
